// servicesData.js
export const servicesData = [
  {
    id: 1,
    title: 'Web Development',
    description: 'Build modern, responsive websites with cutting-edge technologies and seamless user experiences',
    fullDesc: 'Transform your digital presence with our cutting-edge web development solutions. We create stunning, high-performance websites that drive engagement and deliver measurable results for your business.',
    image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?w=800&auto=format&fit=crop',
    gradient: 'from-blue-500 to-purple-600',
    features: [
      'Responsive design that works seamlessly across all devices',
      'SEO optimized architecture for better search engine rankings',
      'Lightning-fast performance with modern optimization techniques',
      'Secure and scalable infrastructure built for growth',
      'Custom CMS integration for easy content management',
      'Ongoing support and maintenance to keep your site running smoothly'
    ],
    technologies: ['React', 'Node.js', 'MongoDB', 'AWS', 'TypeScript', 'Next.js']
  },
  {
    id: 2,
    title: 'Cloud Solutions',
    description: 'Scalable cloud infrastructure and migration services for seamless business operations',
    fullDesc: 'Modernize your infrastructure with enterprise-grade cloud solutions. We help businesses migrate, manage, and optimize their cloud environments for maximum efficiency and cost savings.',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&auto=format&fit=crop',
    gradient: 'from-cyan-500 to-blue-600',
    features: [
      'Seamless cloud migration with zero downtime',
      'Multi-cloud architecture design and implementation',
      'Auto-scaling infrastructure for optimal resource usage',
      'Advanced security and compliance management',
      'Cost optimization and monitoring solutions',
      '24/7 cloud infrastructure support and maintenance'
    ],
    technologies: ['AWS', 'Azure', 'Google Cloud', 'Kubernetes', 'Docker', 'Terraform']
  },
  {
    id: 3,
    title: 'Mobile Development',
    description: 'Native and cross-platform mobile applications that deliver exceptional user experiences',
    fullDesc: 'Create powerful mobile applications that engage users and drive business growth. Our expert team builds native and cross-platform apps with stunning UI and seamless performance.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&auto=format&fit=crop',
    gradient: 'from-purple-500 to-pink-600',
    features: [
      'Native iOS and Android development',
      'Cross-platform solutions with React Native and Flutter',
      'Intuitive and engaging user interface design',
      'Offline functionality and data synchronization',
      'Push notifications and real-time updates',
      'App store optimization and submission support'
    ],
    technologies: ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Firebase', 'GraphQL']
  },
  {
    id: 4,
    title: 'CRM Solutions',
    description: 'Streamline customer relationships with powerful CRM systems that drive sales and loyalty',
    fullDesc: 'Transform your customer relationships with intelligent CRM solutions. We help businesses manage leads, automate sales processes, and deliver exceptional customer experiences at scale.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&auto=format&fit=crop',
    gradient: 'from-green-500 to-teal-600',
    features: [
      'Custom CRM implementation and configuration',
      'Sales pipeline automation and lead management',
      'Customer data integration and analytics',
      'Marketing automation and campaign management',
      'Customer support ticketing systems',
      'Mobile CRM access for on-the-go teams'
    ],
    technologies: ['Salesforce', 'HubSpot', 'Zoho CRM', 'Microsoft Dynamics', 'Custom CRM', 'API Integration']
  },
  {
    id: 5,
    title: 'HRM Solutions',
    description: 'Streamline HR operations with modern human resource management systems',
    fullDesc: 'Empower your HR team with comprehensive HRM solutions. We help businesses automate recruitment, payroll, attendance, and employee management for increased efficiency and employee satisfaction.',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&auto=format&fit=crop',
    gradient: 'from-red-500 to-orange-600',
    features: [
      'End-to-end recruitment and onboarding automation',
      'Payroll processing and tax compliance',
      'Attendance and leave management systems',
      'Performance review and appraisal workflows',
      'Employee self-service portals',
      'HR analytics and reporting dashboards'
    ],
    technologies: ['SAP SuccessFactors', 'Workday', 'BambooHR', 'Zoho People', 'Custom HRMS', 'Biometric Integration']
  },
  {
    id: 6,
    title: 'UI/UX Design',
    description: 'Create stunning user interfaces and experiences that drive engagement and conversions',
    fullDesc: 'Design experiences that users love and businesses need. Our design team crafts beautiful, intuitive interfaces that enhance user satisfaction and drive measurable business results.',
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&auto=format&fit=crop',
    gradient: 'from-pink-500 to-rose-600',
    features: [
      'User research and persona development',
      'Information architecture and user flow design',
      'Interactive prototyping and usability testing',
      'Visual design with modern aesthetics',
      'Responsive design for all screen sizes',
      'Design system creation and documentation'
    ],
    technologies: ['Figma', 'Adobe XD', 'Sketch', 'Principle', 'InVision', 'Framer']
  }
];

export const teamMembers = [
  { name: 'Rajesh Kumar', role: 'CEO & Founder', image: '👨‍💼' },
  { name: 'Priya Sharma', role: 'CTO', image: '👩‍💻' },
  { name: 'Amit Patel', role: 'Lead Developer', image: '👨‍💻' },
  { name: 'Sneha Gupta', role: 'Project Manager', image: '👩‍💼' }
];

export const coreValues = [
  { title: 'Integrity', desc: 'We operate with transparency and honesty', icon: '🤝' },
  { title: 'Innovation', desc: 'We embrace new technologies', icon: '💡' },
  { title: 'Customer Focus', desc: 'Your success is our priority', icon: '🎯' },
  { title: 'Excellence', desc: 'We deliver quality in everything we do', icon: '⭐' }
];